import CloneBulk from './CloneBulk';

export default CloneBulk;
